import React from 'react';
import CustomModal from '../../../components/Modal/CustomModal';
import CustomDescriptionModal from "../../../components/CustomDescriptionModal";
import UnlinkDeviceChangeApp from "../Functionality/UnlinkDeviceChangeApp";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const UnlinkDeviceChangeModal = (props) => {
    const {t, handleUnlinkDevice} = UnlinkDeviceChangeApp(props);

    return (
        <>
            <CustomModal
                title={t('unlink_device')}
                size='md'
                buttonConfirm='confirm'
                {...props}
                onConfirm={handleUnlinkDevice}
            >
                <CustomDescriptionModal>
                    {t("unlink_confirmation_msg")}
                </CustomDescriptionModal>
            </CustomModal>
        </>
    );
};

export default UnlinkDeviceChangeModal;
